import { render } from "./InputProduct.vue?vue&type=template&id=19ccb1c2"
import script from "./InputProduct.vue?vue&type=script&lang=js"
export * from "./InputProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__